/* Allen Boxers redesign. Timings come from the Figma prototype interactions. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) {
    var v = (c / 100).toFixed(2).split('.');
    return 'R$ ' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Overlays: dissolve (css), close button, backdrop, esc ---------- */
  function openOverlay(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function closeOverlay(el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); if (!$('.al-overlay.is-open')) document.documentElement.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var open = t.closest('[data-al-open]');
    if (open) { e.preventDefault(); openOverlay(document.getElementById(open.getAttribute('data-al-open'))); if (open.getAttribute('data-al-focus')) { var f = $(open.getAttribute('data-al-focus')); if (f) f.focus(); } return; }
    if (t.closest('[data-al-close]')) { var o = t.closest('.al-overlay'); if (o) closeOverlay(o); }
    /* A link to a section of this same page does not reload, so the menu has to close by itself */
    var anchor = t.closest('.al-overlay a[href*="#"]'); if (anchor) closeOverlay(anchor.closest('.al-overlay'));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.al-overlay.is-open').forEach(closeOverlay); });

  /* ---------- Hero: auto 4s desktop / 3.5s mobile, 600ms, drag, loop through a clone ---------- */
  $$('[data-al-hero]').forEach(function (hero) {
    var track = $('.al-hero__track', hero), slides = $$('.al-slide', track), dots = $$('.al-hero__dot', hero);
    if (slides.length < 2) return;
    var clone = slides[0].cloneNode(true); clone.setAttribute('aria-hidden', 'true');
    $$('img', clone).forEach(function (i) { i.removeAttribute('fetchpriority'); i.setAttribute('loading', 'lazy'); });
    $$('a,button', clone).forEach(function (a) { a.setAttribute('tabindex', '-1'); });
    track.appendChild(clone);
    var start = parseInt(hero.getAttribute('data-al-start') || '0', 10) || 0;
    var i = Math.min(start, slides.length - 1), timer = null, n = slides.length;
    function paint() { dots.forEach(function (d, k) { var on = k === (i % n); d.classList.toggle('is-on', on); d.setAttribute('aria-current', on ? 'true' : 'false'); }); }
    function place(instant) { track.classList.toggle('is-instant', !!instant); track.style.transform = 'translate3d(' + (-i * 100) + '%,0,0)'; paint(); }
    function wait() { return window.matchMedia('(max-width: 899px)').matches ? 3500 : 4000; }
    function go(k) { i = k; place(false); schedule(); }
    function schedule() { clearTimeout(timer); timer = setTimeout(function () { if (!document.hidden) go(i + 1); else schedule(); }, wait()); }
    track.addEventListener('transitionend', function (e) {
      if (e.target !== track || i < n) return;
      i = 0; place(true); void track.offsetWidth; track.classList.remove('is-instant');
    });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    /* Drag */
    var down = false, sx = 0, dx = 0, moved = false;
    hero.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button) return; down = true; moved = false; sx = e.clientX; dx = 0; clearTimeout(timer); });
    window.addEventListener('pointermove', function (e) {
      if (!down) return; dx = e.clientX - sx;
      if (Math.abs(dx) > 6) { moved = true; track.classList.add('is-instant'); track.style.transform = 'translate3d(calc(' + (-i * 100) + '% + ' + dx + 'px),0,0)'; }
    }, { passive: true });
    function up() {
      if (!down) return; down = false; track.classList.remove('is-instant');
      if (Math.abs(dx) > 60) { i = dx < 0 ? i + 1 : Math.max(i - 1, 0); }
      place(false); schedule();
    }
    window.addEventListener('pointerup', up); window.addEventListener('pointercancel', up);
    hero.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    hero.addEventListener('dragstart', function (e) { e.preventDefault(); });
    place(true); requestAnimationFrame(function () { track.classList.remove('is-instant'); }); schedule();
  });

  /* A page restored by the back button comes back frozen, and a button left busy would stay dead */
  window.addEventListener('pageshow', function (e) { if (e.persisted) $$('.al-busy').forEach(function (el) { el.classList.remove('al-busy'); }); });

  /* ---------- Product videos: the YouTube player only loads on tap, and one plays at a time ---------- */
  var ytCovers = $$('[data-al-yt]');
  ytCovers.forEach(function (b) {
    b.addEventListener('click', function () {
      ytCovers.forEach(function (o) { o.hidden = false; var old = $('iframe', o.parentNode); if (old) old.remove(); });
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube.com/embed/' + b.getAttribute('data-al-yt') + '?autoplay=1&playsinline=1&rel=0';
      f.title = b.getAttribute('aria-label');
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.setAttribute('allowfullscreen', '');
      f.referrerPolicy = 'strict-origin-when-cross-origin';
      b.hidden = true;
      b.parentNode.appendChild(f);
    });
  });

  /* ---------- Reviews: "Escrever avaliação" opens the form of the review app further down, which has no anchor of its own; the app scrolls to its form by itself ---------- */
  $$('[data-al-write]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var app = $('#AreviewsContainer'), btn = app && $('.write_review_button', app), field = app && $('[name="review_comment"]', app), form = field && field.form;
      if (!btn || !form) return;
      e.preventDefault();
      if (form.offsetParent) form.scrollIntoView({ behavior: 'smooth' }); else btn.click();
    });
  });

  /* ---------- Rails ---------- */
  $$('[data-al-railwrap]').forEach(function (w) {
    var rail = $('[data-al-rail]', w), prev = $('[data-al-prev]', w), next = $('[data-al-next]', w);
    if (!rail) return;
    function step() { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : 300; }
    function sync() {
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 4;
      if (prev) prev.classList.toggle('al-round--next', !prev.disabled && next && next.disabled);
      if (next) next.classList.toggle('al-round--next', !next.disabled);
      var pg = $$('[data-al-pg] i', w);
      if (pg.length) {
        var k = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 4 ? pg.length - 1 : Math.round(rail.scrollLeft / step());
        pg.forEach(function (d, j) { d.classList.toggle('is-on', j === Math.min(k, pg.length - 1)); });
        pg[0].parentNode.hidden = rail.scrollWidth <= rail.clientWidth + 1;
      }
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() }); });
    rail.addEventListener('scroll', sync, { passive: true }); window.addEventListener('resize', sync); sync();
    /* Chips: Todos / Até R$ 150 / Kits 10+ */
    $$('[data-al-chip]', w).forEach(function (c) {
      c.addEventListener('click', function () {
        $$('[data-al-chip]', w).forEach(function (o) { o.classList.toggle('is-on', o === c); });
        var maxp = parseInt(c.getAttribute('data-al-maxprice') || '0', 10), minp = parseInt(c.getAttribute('data-al-minpieces') || '0', 10);
        $$('.al-card', rail).forEach(function (card) {
          card.hidden = !!((maxp && +card.getAttribute('data-al-price') > maxp) || (minp && +card.getAttribute('data-al-pieces') < minp));
        });
        rail.scrollLeft = 0; sync();
      });
    });
  });

  /* ---------- Tabs (Por que escolher) ---------- */
  $$('[data-al-tabs]').forEach(function (w) {
    var tabs = $$('[data-al-tab]', w), panes = $$('.al-pane', w), imgs = $$('[data-al-tabimg]', w);
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        tabs.forEach(function (o, j) { o.classList.toggle('is-on', j === k); o.setAttribute('aria-selected', j === k); });
        panes.forEach(function (o, j) { o.classList.toggle('is-on', j === k); });
        imgs.forEach(function (o, j) { o.style.opacity = j === k ? 1 : 0; });
      });
    });
  });

  /* ---------- Real countdown. Without a configured deadline the timer stays hidden ---------- */
  $$('[data-al-deadline]').forEach(function (el) {
    var end = Date.parse(el.getAttribute('data-al-deadline'));
    if (isNaN(end)) { $$('[data-al-timer]', el.closest('[data-al-timerwrap]') || el).forEach(function (t) { t.hidden = true; }); return; }
    var parts = $$('[data-al-h],[data-al-m],[data-al-s]', el);
    function tick() {
      var left = Math.max(0, end - Date.now());
      if (!left) { var w = el.closest('[data-al-timer]'); if (w) w.hidden = true; clearInterval(iv); return; }
      var h = Math.floor(left / 36e5), m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
      var p = function (n) { return (n < 10 ? '0' : '') + n; };
      parts.forEach(function (b) { b.textContent = b.hasAttribute('data-al-h') ? p(h) : b.hasAttribute('data-al-m') ? p(m) : p(s); });
    }
    var iv = setInterval(tick, 1000); tick();
  });

  /* ---------- Favorites ---------- */
  var favs = store.get('al_favs', []);
  function paintFavs() {
    $$('[data-al-fav]').forEach(function (b) { b.setAttribute('aria-pressed', favs.indexOf(b.getAttribute('data-al-fav')) > -1); });
    $$('[data-al-favcount]').forEach(function (c) { c.textContent = favs.length; c.hidden = !favs.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-al-fav]'); if (!b) return;
    e.preventDefault(); var h = b.getAttribute('data-al-fav'), k = favs.indexOf(h);
    if (k > -1) favs.splice(k, 1); else favs.push(h);
    store.set('al_favs', favs); paintFavs();
  });
  paintFavs();
  function renderFavs() {
    var box = $('#al-fav-list'); if (!box) return;
    if (!favs.length) { box.innerHTML = '<div class="al-cart__empty"><p>Você ainda não favoritou nenhum produto.</p></div>'; return; }
    box.innerHTML = '';
    favs.forEach(function (h) {
      fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var a = document.createElement('a'); a.className = 'al-item'; a.href = p.url || ('/products/' + h);
        var img = document.createElement('span'); img.className = 'al-item__img';
        if (p.featured_image) { var i = new Image(); i.src = p.featured_image; i.alt = ''; img.appendChild(i); }
        var t = document.createElement('span'); t.className = 'al-item__t'; t.textContent = p.title;
        var pr = document.createElement('span'); pr.className = 'al-item__p'; pr.textContent = money(p.price);
        a.appendChild(img); a.appendChild(t); a.appendChild(pr); box.appendChild(a);
      });
    });
  }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-al-open="al-favs"]')) renderFavs(); });

  /* ---------- Cart drawer: rendered by Liquid through the Section Rendering API ---------- */
  var drawer = $('#al-cart');
  function refreshCart(open, prevDue) {
    return fetch(window.location.pathname + '?sections=allen-cart-drawer', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) {
      var doc = new DOMParser().parseFromString(d['allen-cart-drawer'], 'text/html');
      var box = $('#al-cart-content'), nw = doc.querySelector('#al-cart-content');
      if (box && nw) { box.innerHTML = nw.innerHTML; }
      afterCart(prevDue);
      if (open) openOverlay(drawer);
    });
  }
  document.addEventListener('al:cartchanged', function () { refreshCart(); });
  function afterCart(prevDue) {
    var box = $('#al-cart-content'); if (!box) return;
    var st = $('[data-al-cartstate]', box); if (!st) return;
    var due = +st.getAttribute('data-al-due'), mult = st.getAttribute('data-al-multiple');
    /* State 4: the gift left the cart */
    if (prevDue !== undefined && due < prevDue) {
      var n = $('[data-al-gift-removed]', box); if (n) n.hidden = false;
      var sug = $('[data-al-sugtitle]', box); if (sug) sug.textContent = 'Leve junto e o gel volta';
    }
    store.set('al_gel_due', due);
    var count = +st.getAttribute('data-al-count');
    $$('[data-al-cartcount]').forEach(function (c) { c.textContent = count; c.hidden = !count; });
    /* Cart state swap: smart animate 300ms */
    var fill = $('[data-al-fill]', box);
    if (fill) { var w = fill.getAttribute('data-al-fill'); var last = store.get('al_gel_w', 0); fill.style.width = last + '%'; void fill.offsetWidth; fill.style.width = w + '%'; store.set('al_gel_w', +w); }
  }
  function curDue() { var st = drawer && $('[data-al-cartstate]', drawer); return st ? +st.getAttribute('data-al-due') : undefined; }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var change = e.target.closest('[data-al-line]');
    if (change) {
      e.preventDefault();
      var prev = curDue(); $('#al-cart-content').classList.add('al-busy');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +change.getAttribute('data-al-line'), quantity: +change.getAttribute('data-al-qty') }) })
        .then(function () { return refreshCart(false, prev); })
        .finally(function () { $('#al-cart-content').classList.remove('al-busy'); });
      return;
    }
    var quick = e.target.closest('[data-al-quick]');
    if (quick) {
      e.preventDefault(); quick.classList.add('al-busy');
      addToCart(+quick.getAttribute('data-al-quick'), 1).then(function () { return refreshCart(true, curDue()); }).finally(function () { quick.classList.remove('al-busy'); });
    }
  });
  /* Cart offers: on the cart page the list is server rendered, so it reloads; in the drawer the section redraws */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-al-bump]') : null; if (!b) return;
    var pick = $('[data-al-bumpvar]', b.parentNode), id = pick ? +pick.value : +b.getAttribute('data-al-bump');
    b.classList.add('al-busy');
    addToCart(id, 1).then(function () {
      if (/^\/cart/.test(location.pathname)) { location.reload(); return; }
      return refreshCart(true, curDue());
    }).catch(function () { window.location.href = '/cart/add?id=' + id + '&quantity=1'; });
  });
  /* direct: the page leaves right after this, so fastpath=1 keeps the Luna loader from starting a resync the navigation would abort */
  function addToCart(id, qty, direct) {
    return fetch('/cart/add.js' + (direct ? '?fastpath=1' : ''), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
  }
  afterCart();

  /* ---------- Product page ---------- */
  var pdp = $('[data-al-pdp]');
  if (pdp) (function () {
    var data = JSON.parse($('[data-al-pdpdata]', pdp).textContent);
    var form = $('[data-al-form]', pdp), idInput = $('[name="id"]', form), buyBtns = $$('[data-al-buy]'), addBtn = $('[data-al-addcart]', pdp);
    var qty = 1, url = new URL(window.location.href);
    var groups = $$('[data-al-optgroup]', pdp), sel = {};
    var initial = data.variants.filter(function (v) { return String(v.id) === url.searchParams.get('variant'); })[0];
    /* Kit, color and size travel with the visitor between kits */
    var carry = { color: url.searchParams.get('al_cor'), size: url.searchParams.get('al_tam') };
    groups.forEach(function (g) {
      var pos = +g.getAttribute('data-al-optgroup'), kind = g.getAttribute('data-al-kind');
      var pick = null;
      if (initial) pick = initial.options[pos - 1];
      else if (kind === 'color' && carry.color && $('[data-al-val="' + carry.color.replace(/"/g, '') + '"]', g)) pick = carry.color;
      else if (kind === 'size' && carry.size && $('[data-al-val="' + carry.size.replace(/"/g, '') + '"]', g)) pick = carry.size;
      else if (kind !== 'size') { var first = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0]; pick = first.options[pos - 1]; }
      sel[pos] = pick;
    });
    function current() { if (!groups.length) return data.variants[0]; return data.variants.filter(function (v) { return v.options.every(function (o, k) { return sel[k + 1] === o; }); })[0]; }
    function kitLabel(v) {
      var p = data.pieces > 1 ? 'Comprar kit de ' + data.pieces : 'Comprar agora';
      return p + ' · ' + money(v ? v.price * qty : data.price * qty);
    }
    function paint() {
      groups.forEach(function (g) {
        var pos = +g.getAttribute('data-al-optgroup'), step = g.closest('.al-step');
        $$('[data-al-val]', g).forEach(function (b) {
          var val = b.getAttribute('data-al-val'), on = sel[pos] === val;
          b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
          var ok = data.variants.some(function (v) { return v.available && v.options[pos - 1] === val && v.options.every(function (o, k) { return k === pos - 1 || !sel[k + 1] || sel[k + 1] === o; }); });
          b.classList.toggle('is-off', !ok);
        });
        if (step) { step.classList.toggle('is-done', !!sel[pos]); var lbl = $('[data-al-sel]', step); if (lbl && sel[pos]) lbl.textContent = sel[pos]; }
      });
      var v = current();
      if (v) { idInput.value = v.id; }
      var label = kitLabel(v);
      buyBtns.forEach(function (b) { var bl = b.getAttribute('data-al-short') ? (data.pieces > 1 ? 'Comprar kit de ' + data.pieces : 'Comprar agora') : label; b.textContent = v && !v.available ? 'Esgotado' : bl; b.disabled = !!(v && !v.available); });
      if (addBtn) addBtn.disabled = !!(v && !v.available);
      $$('[data-al-barprice]').forEach(function (e) { e.textContent = money(v ? v.price : data.price); });
      $$('[data-al-barparc]').forEach(function (e) { e.textContent = '12x de ' + money((v ? v.price : data.price) * data.juros / 12); });
      if (v) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); u.searchParams.delete('al_cor'); u.searchParams.delete('al_tam');
        history.replaceState(null, '', u.toString());
      }
      /* Kit links carry color and size */
      var ckind = {}; groups.forEach(function (g) { ckind[g.getAttribute('data-al-kind')] = sel[+g.getAttribute('data-al-optgroup')]; });
      $$('[data-al-kitlink]', pdp).forEach(function (a) {
        var ku = new URL(a.getAttribute('data-al-kitlink'), window.location.origin);
        if (ckind.color) ku.searchParams.set('al_cor', ckind.color);
        if (ckind.size) ku.searchParams.set('al_tam', ckind.size);
        a.href = ku.pathname + ku.search;
      });
    }
    groups.forEach(function (g) {
      var pos = +g.getAttribute('data-al-optgroup');
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-al-val]'); if (!b) return;
        sel[pos] = b.getAttribute('data-al-val');
        if (g.getAttribute('data-al-kind') === 'color') showColor(pos, sel[pos]);
        g.classList.remove('is-err'); var tip = $('[data-al-tip]', pdp); if (tip && g.getAttribute('data-al-kind') === 'size') { tip.classList.remove('is-err'); tip.textContent = tip.getAttribute('data-al-tip'); }
        paint();
      });
    });
    /* Steps collapse: 250ms */
    $$('[data-al-steptoggle]', pdp).forEach(function (h) {
      h.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        var st = h.closest('.al-step'); var c = st.classList.toggle('is-closed'); h.setAttribute('aria-expanded', !c);
      });
    });
    function requireChoice() {
      var v = current(); if (v) return v;
      var miss = groups.filter(function (g) { return !sel[+g.getAttribute('data-al-optgroup')]; })[0];
      if (miss) {
        miss.classList.add('is-err'); var st = miss.closest('.al-step'); st.classList.remove('is-closed');
        var tip = $('[data-al-tip]', pdp); if (tip) { tip.classList.add('is-err'); tip.textContent = 'Escolha um tamanho para continuar.'; }
        st.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return null;
    }
    /* A failed fetch (rate limit, flaky network) falls back to a plain navigation, which can pass the bot check */
    function addByLink(v) { window.location.href = '/cart/add?id=' + v.id + '&quantity=' + qty; }
    /* Checkout goes through /cart, the entry point of the Luna checkout integration */
    /* Kit app (Profit Pumper): when its widget mounts it owns variant, quantity and price, and handles the form submit itself */
    function kitOn() { return !!$('.prvw_block', pdp); }
    function syncKit() {
      var on = kitOn(); pdp.classList.toggle('al-kitapp', on);
      if (on) buyBtns.forEach(function (b) { if (b.textContent !== 'Comprar agora') b.textContent = 'Comprar agora'; if (b.disabled) b.disabled = false; });
    }
    new MutationObserver(syncKit).observe(pdp, { childList: true, subtree: true });
    pdp.addEventListener('change', function (e) {
      if (!e.target.closest('.prvw_block')) return;
      var val = e.target.value, pos = 0;
      groups.forEach(function (g) { if (g.getAttribute('data-al-kind') === 'color') pos = +g.getAttribute('data-al-optgroup'); });
      if (pos && val) showColor(pos, val);
    });
    buyBtns.forEach(function (b) { b.addEventListener('click', function (e) {
      if (kitOn()) { if (b.type !== 'submit') { e.preventDefault(); var main = buyBtns.filter(function (x) { return x.type === 'submit'; })[0]; if (main) main.click(); } return; }
      e.preventDefault(); var v = requireChoice(); if (!v) return; b.classList.add('al-busy'); addToCart(v.id, qty, true).then(function () { return window.alGiftSync && window.alGiftSync(); }).then(function () { window.location.href = '/cart'; }).catch(function () { addByLink(v); }); }); });
    if (addBtn) addBtn.addEventListener('click', function (e) { e.preventDefault(); var v = requireChoice(); if (!v) return; addBtn.classList.add('al-busy'); addToCart(v.id, qty).then(function () { return refreshCart(true, curDue()); }).catch(function () { addByLink(v); }).finally(function () { addBtn.classList.remove('al-busy'); }); });
    form.addEventListener('submit', function (e) { if (!kitOn()) e.preventDefault(); });
    /* Quantity */
    var qEl = $('[data-al-q]', pdp);
    $$('[data-al-qd]', pdp).forEach(function (b) { b.addEventListener('click', function () { qty = Math.max(1, qty + (+b.getAttribute('data-al-qd'))); if (qEl) qEl.textContent = qty; paint(); }); });
    /* Gallery */
    var tr = $('.al-gal__tr', pdp), slides = $$('.al-gal__s', pdp), th = $$('.al-gal__th button', pdp), pg = $$('.al-gal__pg i', pdp), cnt = $('.al-gal__cnt', pdp), idx = 0;
    function paintGal() { th.forEach(function (t, k) { t.classList.toggle('is-on', k === idx); }); if (th[idx] && th[idx].offsetParent) th[idx].parentNode.scrollTop = th[idx].offsetTop - th[0].offsetTop; pg.forEach(function (t, k) { t.classList.toggle('is-on', k === idx); }); if (cnt) cnt.textContent = (idx + 1) + ' / ' + slides.length; }
    /* Choosing a color shows its photo, even before a size is chosen */
    function showMedia(id) { for (var k = 0; k < slides.length; k++) { if (slides[k].getAttribute('data-al-media') === String(id)) { goTo(k); return; } } }
    function showColor(pos, val) { var v = data.variants.filter(function (x) { return x.media != null && x.options[pos - 1] === val; })[0]; if (v) showMedia(v.media); }
    function goTo(k) { if (k < 0 || k >= slides.length || !tr) return; idx = k; tr.scrollTo({ left: slides[k].offsetLeft - slides[0].offsetLeft }); paintGal(); }
    th.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
    var gp = $('.al-gal__nav--p', pdp), gn = $('.al-gal__nav--n', pdp);
    if (gp) gp.addEventListener('click', function () { goTo((idx - 1 + slides.length) % slides.length); });
    if (gn) gn.addEventListener('click', function () { goTo((idx + 1) % slides.length); });
    if (tr) tr.addEventListener('scroll', function () { var w = slides[0].offsetWidth + (parseFloat(getComputedStyle(tr).columnGap) || 0); var k = Math.round(tr.scrollLeft / w); if (k !== idx) { idx = k; paintGal(); } }, { passive: true });
    /* Feature dots: each label goes beside its dot, authored side first, slid back inside the photo or sideways; when that side has no room it tries the other side, then above or below the dot anywhere across the photo, then farther up or down */
    var pinKey = '';
    function fitPins() {
      var pins = $$('.al-pin', pdp); if (!pins.length) return;
      var box = pins[0].closest('.al-gal__s').getBoundingClientRect(), shift = tr ? tr.scrollLeft : 0, floor = box.bottom - 8;
      /* Only a new photo width or the web fonts arriving can move the labels; phones also fire resize when the toolbar hides on scroll */
      var key = box.width + '|' + (document.fonts ? document.fonts.status : ''); if (key === pinKey) return; pinKey = key;
      var clash = function (a, b, m) { return a.left < b.right + m && a.right > b.left - m && a.top < b.bottom + m && a.bottom > b.top - m; };
      var near = function (q, t) { var cx = (t.left + t.right) / 2, cy = (t.top + t.bottom) / 2; return Math.max(q.left - cx, 0, cx - q.right) + Math.max(q.top - cy, 0, cy - q.bottom); };
      /* Arrows, tags, the heart and the photo counter stay put while the photos scroll, so they are measured as if the first photo were showing */
      var taken = $$('.al-gal__nav, .al-tags, .al-fav, .al-gal__cnt', pins[0].closest('.al-gal__m')).filter(function (e) { return e.offsetParent; }).map(function (e) { var r = e.getBoundingClientRect(); return { left: r.left - shift, right: r.right - shift, top: r.top, bottom: r.bottom }; });
      var dots = pins.map(function (p) { var r = p.getBoundingClientRect(); return { left: r.left - 3, top: r.top - 3, right: r.right + 3, bottom: r.bottom + 3 }; });
      var opts = pins.map(function (pin, i) {
        var lb = $('div', pin), d = dots[i], cands = [];
        lb.style.transform = '';
        if (pin.dataset.l === undefined) pin.dataset.l = pin.classList.contains('is-left') ? '1' : '0';
        [pin.dataset.l === '1', pin.dataset.l !== '1'].forEach(function (left, flip) {
          pin.classList.toggle('is-left', left);
          var r = lb.getBoundingClientRect(), h = r.height, w = r.width, k, s;
          var x = r.left < box.left + 8 ? box.left + 8 - r.left : (r.right > box.right - 8 ? box.right - 8 - r.right : 0), y0 = Math.min(0, floor - r.bottom);
          var add = function (cx, cy, cost) { cands.push({ left: left, x: cx, y: cy, cost: cost, r: { left: r.left + cx, right: r.right + cx, top: r.top + cy, bottom: r.bottom + cy } }); };
          for (k = 0; k * 6 < h; k++) {
            add(x, y0 - k * 6, k * 6 - y0 + flip * 14);
            for (s = 12; s <= 48; s += 12) { add(x + s, y0 - k * 6, k * 6 - y0 + flip * 14 + s / 2); add(x - s, y0 - k * 6, k * 6 - y0 + flip * 14 + s / 2); }
          }
          if (!y0) add(x, 6, 9 + flip * 14);
          /* Farther up or down, for when the dots sit too close together */
          for (k = Math.floor(h / 6) + 1; k * 6 <= 2.2 * h; k++) { add(x, y0 - k * 6, 40 + k * 6 - y0 + flip * 14); add(x, k * 6, 46 + k * 6 + flip * 14); }
          if (!flip) {
            var mid = (d.left + d.right - w) / 2, xs = [mid, d.left - 10, d.right + 10 - w];
            for (k = box.left + 8; k <= box.right - 8 - w; k += 16) xs.push(k);
            xs.push(box.right - 8 - w);
            xs.forEach(function (to, n) {
              to = Math.min(Math.max(to, box.left + 8), box.right - 8 - w);
              var more = n < 3 ? n * 2 : 6 + Math.abs(to - mid) * .1;
              add(to - r.left, d.top - 6 - h - r.top, 30 + more); add(to - r.left, d.bottom + 6 - r.top, 36 + more);
            });
          }
        });
        return cands;
      });
      /* Every placement order is tried (forward and backward past 4 dots); the one that hides fewer labels wins, then the one with fewer clashes. A label never covers a dot, another label, the counter, the tags, the heart or an arrow: when that is all that is left it stays hidden and its dot still shows */
      function arrange(order) {
        var placed = [], pick = [], total = 0, hidden = 0;
        order.forEach(function (i) {
          var best = null, others = dots.filter(function (t, j) { return j !== i; });
          opts[i].forEach(function (c) {
            var q = c.r, n = function (list, m) { return list.filter(function (t) { return clash(q, t, m); }).length; };
            var bad = c.cost + (q.left < box.left + 7.5 || q.right > box.right - 7.5 || q.top < box.top + 8 || q.bottom > floor + .5 ? 5000 : 0) + 1000 * (n(taken.concat(placed), 6) + n(dots, 3));
            others.forEach(function (t) { if (!clash(q, t, 3) && clash(q, t, 12)) bad += 100; });
            if (others.some(function (t) { return near(q, t) < near(q, dots[i]); })) bad += 150;
            if (!best || bad < best.bad) best = { c: c, bad: bad };
          });
          if (best.bad < 1000) placed.push(best.c.r); else hidden++;
          pick[i] = best; total += best.bad;
        });
        return { pick: pick, hidden: hidden, total: total };
      }
      var idx = pins.map(function (p, i) { return i; });
      var perms = function (a) { return a.length < 2 ? [a] : [].concat.apply([], a.map(function (x, k) { return perms(a.slice(0, k).concat(a.slice(k + 1))).map(function (p) { return [x].concat(p); }); })); };
      var win = (pins.length > 4 ? [idx, idx.slice().reverse()] : perms(idx)).map(arrange).reduce(function (a, b) { return b.hidden < a.hidden || (b.hidden === a.hidden && b.total < a.total) ? b : a; });
      pins.forEach(function (pin, i) { var c = win.pick[i].c, lb = $('div', pin); pin.classList.toggle('is-left', c.left); lb.style.transform = c.x || c.y ? 'translate(' + c.x + 'px,' + c.y + 'px)' : ''; lb.style.visibility = win.pick[i].bad < 1000 ? '' : 'hidden'; });
    }
    fitPins(); window.addEventListener('resize', fitPins); if (document.fonts) document.fonts.ready.then(fitPins);
    paint(); paintGal();
    if (initial && initial.media != null) showMedia(initial.media);
    else if (carry.color) groups.forEach(function (g) { if (g.getAttribute('data-al-kind') === 'color' && sel[+g.getAttribute('data-al-optgroup')] === carry.color) showColor(+g.getAttribute('data-al-optgroup'), carry.color); });
    /* Sticky buy bar: appears when the buy button leaves the viewport */
    var bar = $('[data-al-bar]'), anchor = buyBtns[0];
    if (bar && anchor) {
      var ticking = false;
      var syncBar = function () { ticking = false; bar.classList.toggle('is-on', anchor.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(syncBar); } }, { passive: true });
      syncBar();
    }
  })();

  /* ---------- Collection ---------- */
  var coll = $('[data-al-collection]');
  if (coll) (function () {
    var form = $('[data-al-filters]', coll), grid = $('[data-al-grid]', coll);
    function apply() {
      var p = new URLSearchParams(new FormData(form));
      Array.from(p.entries()).forEach(function (kv) { if (kv[1] === '') p.delete(kv[0]); });
      var cur = new URLSearchParams(window.location.search).get('sort_by'); if (cur) p.set('sort_by', cur);
      window.location.search = p.toString();
    }
    if (form) {
      form.addEventListener('change', function (e) { if (e.target.type !== 'number') apply(); });
      form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });
    }
    $$('[data-al-sort]', coll).forEach(function (s) { s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u; }); });
    /* Grid / rows */
    var mode = store.get('al_view', 'grid');
    function view(m) { grid.classList.toggle('is-rows', m === 'rows'); $$('[data-al-view]', coll).forEach(function (b) { var on = b.getAttribute('data-al-view') === m; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); }); store.set('al_view', m); }
    $$('[data-al-view]', coll).forEach(function (b) { b.addEventListener('click', function () { view(b.getAttribute('data-al-view')); }); });
    view(mode);
    /* Filters panel on mobile */
    var fl = $('[data-al-fl]', coll);
    $$('[data-al-flopen]', coll).forEach(function (b) { b.addEventListener('click', function () { fl.classList.add('is-open'); }); });
    $$('[data-al-flclose]', coll).forEach(function (b) { b.addEventListener('click', function () { fl.classList.remove('is-open'); }); });
    /* Load more */
    coll.addEventListener('click', function (e) {
      var more = e.target.closest && e.target.closest('[data-al-more]'); if (!more) return;
      var url = more.getAttribute('data-al-more'); if (!url) return; more.classList.add('al-busy');
      fetch(url).then(function (r) { return r.text(); }).then(function (h) {
        var d = new DOMParser().parseFromString(h, 'text/html');
        $$('[data-al-grid] .al-card', d).forEach(function (c) { grid.appendChild(c); });
        var box = $('[data-al-morebox]', coll), nb = $('[data-al-morebox]', d);
        if (box && nb) box.innerHTML = nb.innerHTML; else if (box) box.remove();
        paintFavs();
      }).catch(function () { window.location.href = url; });
    });
  })();
})();
